import { render, staticRenderFns } from "./DataReportWrapper.vue?vue&type=template&id=45f4d8fa&"
import script from "./DataReportWrapper.vue?vue&type=script&lang=js&"
export * from "./DataReportWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports